import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "../css/Timeline.css";

const timelineData = [
  { year: "1974", text: "Colombo Dockyard incorporated with an initial facility of three dry docks" },
  { year: "1975", text: "Shipbuilding begins in Sri Lanka and first patrol boat made for SL Navy" },
  { year: "1976", text: "Ceylon Shipping Agency incorporated in collaboration with Ceylon Shipping Corp" },
  { year: "1977", text: "The Colombo Port Commission gets its first vessel, a 100 Ton Barge" },
  { year: "1978", text: "First Towing Tug Boat built in Sri Lanka for the Colombo Port Commission" },
  { year: "1981", text: "Incorporation of Dockyard General Engineering Services" },
  { year: "1982", text: "First Offshore Patrol Vessel (OPV) built for Sri Lanka Navy" },
  { year: "1983", text: "First export order in shipbuilding for Burma Ports Corporation, Myanmar" },
  { year: "1987", text: "First Shipbuilding project for the Republic of Maldives" },
  { year: "1988", text: "Colombo Drydocks Ltd begins operations at the newly built 125,000 DWT dry dock" },
  { year: "1992", text: "Aluminium shipbuilding begins with Fast Patrol Boat production for SL Navy" },
  { year: "1993", text: "Restructuring of CDL and CDD with the collaboration of Onomichi Dockyard, Japan" },
  { year: "1997", text: "Diversification of business activities into heavy engineering" },
  { year: "1998", text: "First aluminium coastal surveillance vessel built for the Republic of Maldives" },
  { year: "1999", text: "ISO 9001 certification for Lloyds Register of Quality Assurance (LRQA)" },
  { year: "2002", text: "Quality Management System certification upgraded to ISO 9001: 2000" },
  { year: "2004", text: "Diversification into Offshore Engineering and first project for Indian Navy" },
  { year: "2005", text: "Expansion of shipbuilding activities into the Middle Eastern market" },
  { year: "2006", text: "Building of the largest Aluminium hull ship built in Sri Lanka to date" },
  { year: "2007", text: "Greatship (India) Ltd gets first Anchor Handling Tug / Supply Vessel (AHTSV)" },
  { year: "2008", text: "Colombo Dockyards sees many new structural and technological adaptations" },
  { year: "2009", text: "National recognition and strong performance during a global downturn" },
  { year: "2010", text: "Colombo Dockyard in the Forbes list of top 200 Asian firms" },
  { year: "2011", text: "Colombo Dockyard order books at capacity for Multipurpose Platform Supply Vessels" },
  { year: "2012", text: "Start of construction of 400 passenger cum cargo vessel to India" },
  { year: "2013", text: "Two decades of valuable collaboration with Onomichi Dockyard Co. Ltd, Japan" },
  { year: "2014", text: "Celebrating forty years of shipbuilding and ship repairing experience" },
  { year: "2016", text: "ISO 14001:2015 and OHSAS 18001:2007 certification" },
  { year: "2019", text: "Establishment of Afloat Repair Service Unit (RRARS) / Delivery of Cable Laying Vessel to Japan" },
  { year: "2020", text: "Contracting to build Hybrid Eco Bulk Carriers to Norway" },
  { year: "2021", text: "Establishment of office at Trincomalee Port" },
  { year: "2022", text: "Energy Management system certification ISO 50001: 2018" },
  { year: "2023", text: "Contracting to build Hybrid Eco Bulk Carriers to Norway" },
  { year: "2024", text: "Celebrating 50 years of excellence" },
];

const Timeline = () => {
  const [current, setCurrent] = useState(0);
  const [translateX, setTranslateX] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  const stageRef = useRef(null);
  const itemRefs = useRef([]);

  const centerActiveItem = () => {
    const stage = stageRef.current;
    const activeItem = itemRefs.current[current];

    if (!stage || !activeItem) return;

    const stageCenter = stage.offsetWidth / 2;
    const itemCenter = activeItem.offsetLeft + activeItem.offsetWidth / 2;

    setTranslateX(stageCenter - itemCenter);
  };

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useLayoutEffect(() => {
    if (!isMobile) {
      centerActiveItem();

      window.addEventListener("resize", centerActiveItem);
      return () => window.removeEventListener("resize", centerActiveItem);
    }
  }, [current, isMobile]);

  const navigate = (dir) => {
    const next = current + dir;

    if (next >= 0 && next < timelineData.length) {
      setCurrent(next);
    }
  };

  return (
    <section id="time-line" data-aos="zoom-in">
      <h3>Colombo Dockyard Timeline</h3>

      {!isMobile ? (
        <div className="cd-timeline" ref={stageRef}>
          <div className="cdl-tl-line"></div>

          <ul
            className="cd-timeline-items"
            style={{ transform: `translateX(${translateX}px)` }}
          >
            <li className="first-dummy">
              <div className="cdl-caption">&nbsp;</div>
            </li>

            {timelineData.map((item, i) => {
              const isActive = i === current;
              const isNeighbor = i === current - 1 || i === current + 1;

              let itemClass = "hidden-item";

              if (isActive) {
                itemClass = "active";
              } else if (isNeighbor) {
                itemClass = "neighbor";
              }

              return (
                <li
                  key={i}
                  ref={(el) => (itemRefs.current[i] = el)}
                  className={`timeline-item ${itemClass}`}
                  onClick={() => setCurrent(i)}
                >
                  <div className="timeline-year">{item.year}</div>
                  <div className="cdl-caption">&nbsp;</div>
                </li>
              );
            })}

            <li className="last-dummy">
              <div className="cdl-caption">&nbsp;</div>
            </li>
          </ul>
        </div>
      ) : (
        <div className="mobile-timeline-view">
          <div className="mobile-year mobile-year-prev">
            {current > 0 ? timelineData[current - 1].year : ""}
          </div>

          <div className="mobile-year mobile-year-active">
            {timelineData[current].year}
          </div>

          <div className="mobile-year mobile-year-next">
            {current < timelineData.length - 1
              ? timelineData[current + 1].year
              : ""}
          </div>
        </div>
      )}

      <p className="timeline-caption">{timelineData[current].text}</p>

      <Link to="/ourtimeline.html" className="timeline-button">
        View our timeline
      </Link>

      <div className="timeline-nav">
        <button
          onClick={() => navigate(-1)}
          disabled={current === 0}
          className="timeline-nav-btn"
          aria-label="Previous timeline year"
        >
          <svg
            width="25"
            height="25"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>

        <button
          onClick={() => navigate(1)}
          disabled={current === timelineData.length - 1}
          className="timeline-nav-btn"
          aria-label="Next timeline year"
        >
          <svg
            width="25"
            height="25"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      </div>
    </section>
  );
};

export default Timeline;